import { render } from "./OlapGraphVisualizer.vue?vue&type=template&id=506b8ff1"
import script from "./OlapGraphVisualizer.vue?vue&type=script&lang=js"
export * from "./OlapGraphVisualizer.vue?vue&type=script&lang=js"

import "./OlapGraphVisualizer.vue?vue&type=style&index=0&id=506b8ff1&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__